import React from 'react';

import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

/**
 * Displays an error in the Rovo chat UI.
 */
export const ErrorMessage = ({ errorMessage }: { errorMessage: string }): React.JSX.Element => {
	return (
		<Inline space="space.050" alignBlock="center">
			<StatusErrorIcon color={token('color.icon.danger')} label="" size="small" />
			<Text color="color.text.danger">{errorMessage}</Text>
		</Inline>
	);
};
